export default __webpack_public_path__ + "static/media/anglictina.83c19976.svg";